import BedSprs from "@inter-ikea-range/bed-sprs";
import BedroomExperience from "@inter-ikea-range/bedroom-experience";
import Beds from "@inter-ikea-range/beds";
import BedsideTables from "@inter-ikea-range/bedside-tables";
import ChestOfDrawers from "@inter-ikea-range/chest-of-drawers";
import DecorationsAndAccessories from "@inter-ikea-range/decorations-and-accessories";
import HomeOffice from "@inter-ikea-range/home-office";
import BedroomLighting from "@inter-ikea-range/lighting";
import Mattresses from "@inter-ikea-range/mattresses";
import BedroomMirrors from "@inter-ikea-range/mirrors";
import Rugs from "@inter-ikea-range/rugs";
import BedroomSeating from "@inter-ikea-range/seating";
import BedroomStorage from "@inter-ikea-range/storage";
import Tables from "@inter-ikea-range/tables";
import Wardrobes from "@inter-ikea-range/wardrobes";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

// room experience
export const bedroomExperience = (settings: EnvironmentSettings) => BedroomExperience(settings);

// range packages
export const bedroomPackages = (settings: EnvironmentSettings): Experience[] => {
  const wardrobesWithPax = {
    ...Wardrobes(settings),
    consumes: ["storageone-pax"],
  };

  return [
    Beds(settings),
    BedsideTables(settings),
    BedSprs(settings),
    ChestOfDrawers(settings),
    wardrobesWithPax,
    Rugs(settings),
    BedroomLighting(settings),
    BedroomMirrors(settings),
    BedroomStorage(settings),
    HomeOffice(settings),
    Tables(settings),
    BedroomSeating(settings),
    Mattresses(settings),
    DecorationsAndAccessories(settings),
  ];
};
